var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearchToolsIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "reasearch-tools-icon-white",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 68 68",
    style: {
      enableBackground: "new 0 0 68 68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.6,8.5L47.6,8.5c-1.6,6-7.3,11.7-13.4,13.4l0,0c6,1.6,11.7,7.3,13.4,13.4l0,0c1.6-6,7.3-11.7,13.4-13.4l0,0 C55,20.3,49.3,14.6,47.6,8.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 15.1,
    width: 17.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 44.3,
    width: 17.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.7,
    y: 44.3,
    width: 17.8,
    height: 15.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchToolsIconWhite);
export default __webpack_public_path__ + "static/media/research-tools-icon-white.204c3eef4b775d05ab89f3916e1cc0ae.svg";
export { ForwardRef as ReactComponent };